"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var WixSocialPosts = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M18.2802608,12.7247289 L18.5077431,12.9514994 L18.7289475,12.7310552 C19.7052581,11.7541062 21.2881706,11.7541062 22.2641621,12.7307361 C23.1976,13.6647846 23.238315,15.1534304 22.3862113,16.135859 L22.2644814,16.2665892 L18.5148449,20.01758 L14.7477356,16.2632613 C13.8138759,15.3325723 13.7708147,13.8463102 14.6203544,12.8644095 L14.7477356,12.7277325 C15.7228726,11.7525955 17.303467,11.7512516 18.2802608,12.7247289 Z M19,4 C19.5522847,4 20,4.44771525 20,5 L20,11 L19,11 L19,5 L5,5 L5,19 L14,19 L14,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,5 C4,4.44771525 4.44771525,4 5,4 L19,4 Z M15.5688729,13.3317358 L15.4551428,13.4345387 C14.903673,13.987874 14.8706216,14.8548314 15.3507685,15.4415268 L15.4536389,15.554953 L18.513,18.604 L21.532631,15.5851237 L21.6307756,15.4806362 C22.1439297,14.8889977 22.1142078,13.9953599 21.5568242,13.4376116 C21.0079704,12.8883989 20.1392415,12.8541251 19.548995,13.3360995 L19.4348361,13.4393781 L18.507634,14.3633937 L17.5743575,13.4330371 C17.024911,12.8854561 16.157054,12.851941 15.5688729,13.3317358 Z M8,7 C9.1045695,7 10,7.8954305 10,9 C10,10.1045695 9.1045695,11 8,11 C6.8954305,11 6,10.1045695 6,9 C6,7.8954305 6.8954305,7 8,7 Z M15,9 L15,10 L11,10 L11,9 L15,9 Z M8,8 C7.44771525,8 7,8.44771525 7,9 C7,9.55228475 7.44771525,10 8,10 C8.55228475,10 9,9.55228475 9,9 C9,8.44771525 8.55228475,8 8,8 Z M17,7 L17,8 L11,8 L11,7 L17,7 Z" })));
};
WixSocialPosts.displayName = 'WixSocialPosts';
exports.default = WixSocialPosts;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=WixSocialPosts.js.map